import { AppConfig } from "app/core";
import { commonEnvironment } from "./environment-common";

export const environment: AppConfig = {
  ...commonEnvironment,
  botName: "bscc",
  backendBaseUrl: "https://ui.bscc-lpsb-bot-out-preprod.probayes.net/v0/",

  headerLogoUrl: "/assets/specific/bscc/logo_cropped.svg",
  reducedBotLogoUrl: "/assets/specific/bscc/logo_cropped.svg",
  reducedBotHasWelcomeText: true,
  messageAvatarUrl: "/assets/specific/bscc/logo_cropped.svg",
};
